import React, {useState} from 'react';

import ConfirmDialog from './ConfirmDialog.js';
import LogTwoPartTable from './LogTwoPartTable.js';
//import SleepLogGraph from './SleepLogGraph.js';
//import TabPanel from './TabPanel.js';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from '@material-ui/core/Snackbar';
//import InputLabel from "@material-ui/core/InputLabel";
//import Select from "@material-ui/core/Select";
//import MenuItem from "@material-ui/core/MenuItem";
//import FormControl from '@material-ui/core/FormControl';
//import Box from '@material-ui/core/Box';

//import AppBar from '@material-ui/core/AppBar';
//import Tabs from '@material-ui/core/Tabs';
//import Tab from '@material-ui/core/Tab';
//import Paper from '@material-ui/core/Paper';

//import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
//import Checkbox from '@material-ui/core/Checkbox';

import {firestore} from './firebase.js';
//import {UserContext} from './UserContext.js';
import {useCollection} from 'react-firebase-hooks/firestore';

import {CSVLink} from 'react-csv';

const useStyles = makeStyles((theme) => ({
    textForm: {
      textAlign: "left",
      //flexGrow: 1,
      //marginLeft:theme.spacing(1),
      //padding: theme.spacing(2),
      //margin: theme.spacing(2),
    },
    text: {
      textAlign: "center",
      //padding: theme.spacing(2),
      //margin: theme.spacing(2),
    },
    textExplanation: {
      textAlign: "justify",
      //padding: theme.spacing(2),
      //margin: theme.spacing(2),
    },
    select: {
      minWidth: 250,
      marginLeft:theme.spacing(3),
      //alignItems: "right",
      //marginLeft: "auto",
      //marginRight: 20,
    },
    table: {
        minWidth: 650,
    },
    graph: {
      maxWidth: 450,
      maxHeight: 450,
      margin: 'auto',
    },
    paper: {
      justifyContent: 'center',
      margin: 'auto',
      flexGrow: 1,
    },
    button: {
           //padding: theme.spacing(2),
        margin: theme.spacing(1),
          alignItems: 'center',
          width: 200,
      }
})); 

export default function LogTwoPartHistory(props) {
    const classes = useStyles();
    const {item, tableDataTypes, /*graphDataTypes,*/ user} = props;

    const [commentOpen, setCommentOpen] = useState(false); // privacy dialog boolean
    const [currentComment, setCurrentComment] = useState("No Comment");
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [currentDocumentID, setCurrentDocumentID] = useState("");
    const [entryDeletedNotice, setEntryDelectedNotice] = useState(false);
    //const [tabValue, setTabValue] = useState(0);
    //const [dataPointsShown, setDataPointsShown] = useState(0);
    //const dataPointOptions = [{value: 0, text: "Show All Entries"}, {value:5, text: "Show Last 5 Entires"}, {value:10, text: "Show Last 10 Entries"}, {value:20, text:"Show Last 20 Entries"}];

    // HANDLE SHOWING COMMENTS DIALOG
    function handleCommentOpen(comment) {
        setCommentOpen(true);
        if (comment !== "") {
            setCurrentComment(comment);
        } else {
            setCurrentComment("No Comment");
        }
      }
    
    function handleCommentClose () { // If pt agrees to privacy, allow to move forward to app
        setCommentOpen(false);
      }
     // HANDLE DELETE DOCUMENT DIALOG
    function handleConfirmDeleteOpen(id) {
          setCurrentDocumentID(id);
          setConfirmDeleteOpen(true);
      }

    function handleConfirmDeleteAgree() {
        setConfirmDeleteOpen(false);
        firestore.collection(user ? `Users/${user.uid}/${item.toLowerCase()}` : "Users").doc(currentDocumentID).delete()
        .then(()=>
          setEntryDelectedNotice(true));
        setCurrentDocumentID("");
      }

    function handleConfirmCancel() {
          setConfirmDeleteOpen(false);
          setCurrentDocumentID("");
      }

      const handleEntryDeletedNoticeClose  = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        if (event) {
          event.preventDefault();
        };
        setEntryDelectedNotice(false);
      };

      // HANDLE TAB VALUE CHANGE
      /*
      function handleTabValueChange(event, newValue) {
        event.preventDefault();
        setTabValue(newValue);
      }*/

      // HANDLE DATA POINT CHANGE
      /*
      function handleDataPointsShownChange(event) {
        setDataPointsShown(event.target.value);
      } *?

      /*
      const showSelectDataPoints = <><FormControl className={classes.select}>
      <InputLabel htmlFor="number-of-data-points">Entries</InputLabel>
        <Select id="number-of-data-points" value={dataPointsShown} onChange={handleDataPointsShownChange}>
              {dataPointOptions.map((option)=><MenuItem value={option.value} key={option.value}>{option.text}</MenuItem>)}
        </Select>
      </FormControl></>; */

    //Load Data
    // Note "asc" for ascending and "desc" for descenging order
    // orderBy = order by bedtime and in descending order
    const [value, loading , error] = useCollection(
      firestore.collection(user ? `Users/${user.uid}/${item.toLowerCase()}` : "Users").orderBy("date"), //only load if user is logged in
      {
        snapshotListenOptions: { includeMetadataChanges: true },
      }
    );

    // Prep data to creat a CSV
    // Summary Data
    const csvSummaryDataHeader = ["Date", tableDataTypes[0].title, tableDataTypes[1].title, "Comments"];
    function csvSummaryDataBody() {
    if (value) {
      return value.docs.map(doc => [doc.get("date").toDate().toLocaleDateString("en-US"), `${doc.get("surveyPartAScore")}, ${doc.get("surveyPartAInterpretation")}`, `${doc.get("surveyPartBScore")}, ${doc.get("surveyPartBInterpretation")}`, doc.get("comments")]);
    }
    return [];
  }
    const csvSummaryData = [csvSummaryDataHeader, ...csvSummaryDataBody()];

    // Individual Survey Data
    function csvSurveyHeader(surveyPartData) { // either "surveyPartACompleteData" or "surveyPartBCompleteData"
      if (value) {
        const completeQuestionsData = value.docs[0].get(surveyPartData).map((question, index)=>`${index+1}) ${question.text}`);
        return ["Date", ...completeQuestionsData];
      }
      return [];
    }
    //console.log(csvSurveyHeader("surveyPartACompleteData")); // just for testing, REMOVE

    function csvSurveyDataBody (surveyPartData) {
      if (value) {
        const questions = value.docs.map(doc => [doc.get("date").toDate().toLocaleDateString("en-US"), ...doc.get(surveyPartData).map(question=>`${question.choice}, ${question.answers[question.choice]}`)]);
        return questions;
      }
      return [];
    }

    // CONSIDER ADDING A NUMBER/DATA ONLY CSV SO PEOPLE CAN GRAPH

    //console.log(csvSurveyDataBody("surveyPartACompleteData")[0]);

    const csvSurveyPartAData = [csvSurveyHeader("surveyPartACompleteData"), ...csvSurveyDataBody("surveyPartACompleteData")];
    const csvSurveyPartBData = [csvSurveyHeader("surveyPartBCompleteData"), ...csvSurveyDataBody("surveyPartBCompleteData")];
    

    //console.log(csvSurveyPartAData);
    //console.log(csvSurveyPartBData);

    ////////////////////////
    //Display results///////
    ////////////////////////

    if (error) {
      return <Typography>Error: {JSON.stringify(error)}</Typography>;
  } else if (loading) {
      return  <CircularProgress />;
  } else if (user && value) { //Only show this if user is logged in and there is a stored value
      return <>
      <LogTwoPartTable user={user} value={value} onCommentOpen={handleCommentOpen} onConfirmDeleteOpen={handleConfirmDeleteOpen}/>
      <br /><br />
      <Typography variant="h6" color="inherit">Downloadable Spreadsheets</Typography>
      <Typography color="inherit">Click options below to download your data in spreadsheet (CSV*) format</Typography>
      <br />
      <Typography>
        <Button variant="contained" className={classes.button} color="inherit"><CSVLink data={csvSummaryData} filename={`${props.item.toLowerCase()}_summary.csv`}>Survey Summaries</CSVLink></Button> 
        <Button variant="contained" className={classes.button} color="inherit"><CSVLink data={csvSurveyPartAData} filename={`${props.item.toLowerCase()}_${tableDataTypes[0].title.toLowerCase()}.csv`}>{tableDataTypes[0].title}</CSVLink></Button>
        <Button variant="contained" className={classes.button} color="inherit"><CSVLink data={csvSurveyPartBData} filename={`${props.item.toLowerCase()}_${tableDataTypes[1].title.toLowerCase()}.csv`}>{tableDataTypes[1].title}</CSVLink></Button>
      </Typography>
        <br />
        <Typography variant="subtitle2" color="inherit">*CSV stands for "Comma Separated Values." It is a shareable file that can be opened on Excel or Google Sheets. This document can be used to send your log to your mental health provider or for your own records.</Typography>
          <br /><br />
      <ConfirmDialog title={"Comments"} description={currentComment} agree="OK" disagree={null} open={commentOpen} onCloseClick= {null} onAgreeClick={handleCommentClose}/>
        <ConfirmDialog title={"Erase?"} description={`Erase Data From ${currentDocumentID}?`} agree="Yes" disagree="Cancel" open={confirmDeleteOpen} onCloseClick= {handleConfirmCancel} onAgreeClick={handleConfirmDeleteAgree}/>
        <Snackbar open={entryDeletedNotice} autoHideDuration={3000} onClose={handleEntryDeletedNoticeClose} message="Entry deleted." action={<Button color="primary" onClick={handleEntryDeletedNoticeClose}>OK</Button>}/>
      </>;
    }

    return null;
  }